import { bech32 } from 'bech32';
import BIP32Factory from 'bip32';
import * as bip39 from 'bip39';
import * as bitcoin from 'bitcoinjs-lib';
import encHex from 'crypto-js/enc-hex';
import ripemd160 from 'crypto-js/ripemd160';
import sha256 from 'crypto-js/sha256';
import * as ecc from '@bitcoinerlab/secp256k1';

bitcoin.initEccLib(ecc);
const bip32 = BIP32Factory(ecc);

export function mnemonicToPair(mnemonic: string) {
  const path = "m/44'/118'/0'/0/0";
  const seed = bip39.mnemonicToSeedSync(mnemonic);
  const node = bip32.fromSeed(seed);
  const child = node.derivePath(path);
  return { privateKey: child.privateKey!, publicKey: child.publicKey };
}

export function getAddress(publicKey?: Buffer) {
  if (!publicKey) {
    return '';
  }

  return getBech32Address(publicKey, 'dydx');
}

export function extractCleanSignatureHash(signatureHash: string) {
  if (!signatureHash) {
    return '';
  }

  return signatureHash.replace(/^0x/, '').slice(0, -1);
}

export function getBech32Address(publicKey: Buffer, prefix: string) {
  const encodedBySha256 = sha256(encHex.parse(publicKey.toString('hex'))).toString(encHex);

  const encodedByRipemd160 = ripemd160(encHex.parse(encodedBySha256)).toString(encHex);

  const words = bech32.toWords(Buffer.from(encodedByRipemd160, 'hex'));
  const result = bech32.encode(prefix, words);

  return result;
}
